// extracted by mini-css-extract-plugin
export default {"contents":"ZE-z","sectionHeading":"_E-z"};